import { render, staticRenderFns } from "./ipproxy.vue?vue&type=template&id=6c87a5e0"
import script from "./ipproxy.vue?vue&type=script&lang=js"
export * from "./ipproxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports